export default "__VITE_ASSET__DaJGp0aR__"